var storefrontApp = angular.module("storefrontApp");

//#region URL Service
storefrontApp.service("urlService", [
    "$location",
    "catalogService",
    "configs",
    "$http",
    function ($location, catalogService, configs, $http) {
        function normalizeListingSlug(value) {
            return (value || "").toString().replace(/ /g, "-").toLowerCase();
        }

        return {
            normalizeListingSlug: normalizeListingSlug,
            getCategoryListingUrl: function (categoryName, productType) {
                var type = normalizeListingSlug(productType);
                var slug = normalizeListingSlug(categoryName);
                if (type === "fontpack") {
                    return "/embroidery-font-bundles/" + slug;
                }
                return window.__env.categoryListingKeys.categoryListingPage
                    .replace("{catname}", slug)
                    .replace("{type}", type);
            },
            getBrandListingUrl: function (brand, productType, isFree) {
                var type = normalizeListingSlug(productType);
                var slug = normalizeListingSlug(brand);
                if (isFree) {
                    return "/freeembroiderydesigns/brands/" + slug;
                }
                if (type === "fontpack") {
                    return "/embroidery-font-bundles/brands/" + slug;
                }
                return "/" + type + "/brands/" + slug;
            },
            getSubCategoryCollectionsUrl: function (
                categoryName,
                productType,
                isFree
            ) {
                var type = normalizeListingSlug(productType);
                var slug = normalizeListingSlug(categoryName);
                if (type === "fontpack") {
                    return (
                        "/embroidery-font-bundles/" +
                        slug +
                        "/collections"
                    );
                }
                var base = isFree
                    ? "/freeembroiderydesigns/"
                    : "/" + type + "/";
                return base + "categories/" + slug;
            },
            getBrandUrl: function (item) {
                if (item) {
                    if (catalogService.isSubscription(item.productDefinition)) {
                        return "/account#/#customersubscription";
                    }
                    var definitionName = (
                        item.productDefinition ||
                        item.definitionName ||
                        ""
                    ).toLowerCase();
                    if (
                        definitionName === "fontpack" &&
                        (item.catalogId || item.brand)
                    ) {
                        return (
                            "/embroidery-font-bundles/brands/" +
                            normalizeListingSlug(item.catalogId || item.brand)
                        );
                    }
                    if (catalogService.isDigitalProduct(item.productType)) {
                        if (
                            item.catalogId &&
                            item.catalogId.toLowerCase() == "annthegranpl"
                        )
                            item.catalogId = "ann the gran";

                        if (
                            catalogService.isCustomDigitizing(
                                item.productDefinition
                            )
                        )
                            return "/customdigitizing";
                        else if (
                            catalogService.isInstantLettering(
                                item.productDefinition
                            )
                        )
                            return "/";
                        else if (
                            item.catalogId &&
                            item.catalogId.toLowerCase() == "atg freedesigns"
                        )
                            return "/freeembroiderydesigns";
                        else
                            return (
                                "/all/brands/" +
                                item.catalogId
                                    .replace(/ /g, "-")
                                    .toLowerCase() +
                                "/all"
                            );
                    } else if (
                        catalogService.isClubMembership(item.productType)
                    ) {
                        return "/annsclub";
                    }

                    if (
                        item.productDefinition &&
                        item.productDefinition.toLowerCase() ==
                            "instantlettering"
                    ) {
                        return "/onlinelettering";
                    }
                    if (
                        item.productDefinition &&
                        item.productDefinition.toLowerCase() ==
                            "embroiderypatch"
                    ) {
                        return "/all/productlistings";
                    }
                } else return "/";
            },
            getBrandUrlByBrand: function (brand) {
                return (
                    "/all/brands/" +
                    brand.replace(/ /g, "-").toLowerCase() +
                    "/all/"
                );
            },
            getBrandImageUrl: function (brand) {
                return (
                    "/common/images/brandicons/" +
                    brand.replace(/ /g, "-").toLowerCase() +
                    ".png"
                );
            },
            getImageUrl: function (item) {
                if (angular.isDefined(item)) {
                    var imgUrl = "";
                    if (window.__env && window.__env.elasticBaseUrl) {
                        configs = window.__env;
                    }

                    //#region  Definition Name
                    var rawDefinitionName = "";
                    if (angular.isDefined(item.definitionName)) {
                        rawDefinitionName = item.definitionName;
                    } else if (angular.isDefined(item.productDefinition)) {
                        rawDefinitionName = item.productDefinition;
                    }
                    var definitionName = (rawDefinitionName || "")
                        .replace(/_/g, "-")
                        .replace(/ /g, "-")
                        .toLowerCase();
                    if (
                        definitionName == "font-letter" ||
                        definitionName == "fontletter"
                    ) {
                        definitionName = "fontletter";
                    }
                    // Some payloads surface stockdesign for font-letter items; honor explicit URL/definition hints.
                    if (definitionName == "stockdesign") {
                        var urlHint =
                            item.productUrl || item.url || item.prdUrl || "";
                        var explicitDefHint =
                            (item.product && item.product.definitionName) ||
                            item.definition_name ||
                            "";
                        if (
                            (urlHint &&
                                urlHint.toLowerCase().indexOf("/fontletter/") >
                                    -1) ||
                            (explicitDefHint &&
                                explicitDefHint
                                    .toString()
                                    .replace(/[\s\-_]/g, "")
                                    .toLowerCase() == "fontletter")
                        ) {
                            definitionName = "fontletter";
                        }
                    }
                    if (definitionName.toLowerCase() == "svg") {
                        definitionName = "printart";
                    }
                    if (
                        definitionName.toLowerCase().indexOf("pdf-patterns") >
                            -1 ||
                        definitionName.toLowerCase() == "hand-embroidery"
                    ) {
                        definitionName = "projectpack";
                    }
                    //#endregion

                    //#region Subscription
                    if (
                        definitionName.toLowerCase() ==
                        catalogService.productDefinition.subscription.toLowerCase()
                    ) {
                        return (
                            "/embroiderydesigns/images/subscriptions/" +
                            (item.size || "medium") +
                            "/subscription.jpg"
                        );
                    }
                    //#endregion

                    // #region Lookbook
                    if (definitionName.toLowerCase() == "lookbook") {
                        var lookbookBaseUrl = window.__env.lookbookImgBaseUrl;
                        var isCover = angular.isUndefined(item.pageNumber);
                        if (isCover) {
                            lookbookBaseUrl += "supersize/cover/";
                        } else {
                            lookbookBaseUrl += "thumbnail/";
                        }
                        return (
                            lookbookBaseUrl +
                            item.lookbookId +
                            (isCover ? "" : "-" + item.pageNumber) +
                            ".jpg"
                        ).toLowerCase();
                    }
                    //#endregion

                    //#region Project Tutorials
                    if (
                        item.definitionName &&
                        item.definitionName.toLowerCase() == "project_tutorial"
                    ) {
                        if (
                            item.imgName == null ||
                            item.imgName === undefined ||
                            item.imgName.indexOf("_t") < 0
                        ) {
                            return (
                                window.__env.projectTutorialsBaseUrl +
                                item.imgName
                            ).toLowerCase();
                        } else {
                            return (
                                window.__env.projectTutorialsBaseUrl +
                                item.imgName.substring(
                                    0,
                                    item.imgName.lastIndexOf("_t")
                                ) +
                                item.imgName.substring(
                                    item.imgName.lastIndexOf("_t") + 2
                                )
                            ).toLowerCase();
                        }
                    }
                    //#endregion

                    //#region Gift Certificate
                    if (
                        definitionName.toLowerCase() == "giftcertificate" &&
                        item.giftCardItems &&
                        item.giftCardItems.length > 0
                    ) {
                        imgUrl = "/embroiderydesigns/images/giftcards/medium/";
                        return imgUrl.toLowerCase();
                    }
                    //#endregion

                    // #region Custom Digitizing
                    if (
                        definitionName.toLowerCase() == "customdigitizing" &&
                        item.customDigitizingItems &&
                        item.customDigitizingItems.length > 0
                    ) {
                        imgUrl =
                            configs.cdDigitizerImagesUrl +
                            item.customDigitizingItems[0].imgLrgThumbnail.split(
                                "|"
                            )[0];
                        return imgUrl.toLowerCase();
                    } else if (
                        angular.isDefined(item.cdLineItems) &&
                        item.cdLineItems != null &&
                        item.cdLineItems.length > 0
                    ) {
                        imgUrl =
                            configs.cdDigitizerImagesUrl +
                            item.cdLineItems[0].imgLrgThumbnail.split("|")[0];
                        return imgUrl.toLowerCase();
                    }
                    //#endregion

                    // #region Instant Lettering
                    else if (
                        definitionName.toLowerCase() == "instantlettering"
                    ) {
                        if (item.ilLineItems[0].requestId.length > 7)
                            imageUrl =
                                window.__env.ilImageBaseUrl +
                                item.ilLineItems[0].requestId +
                                ".jpg";
                        else
                            imageUrl =
                                "/embroiderydesigns/images/instant_lettering.jpg";
                        return imageUrl.toLowerCase();
                    }
                    //#endregion

                    // #region Embroidery Patches
                    var currentItemCatalog = item.catalogId;
                    var currentProductCode = item.sku;

                    if (definitionName.toLowerCase() == "embroiderypatch") {
                        definitionName = "stockdesign";
                        var patchItem = null;

                        function getFirstValidItem(array) {
                            return angular.isDefined(array) &&
                                array != null &&
                                array.length > 0
                                ? array[0]
                                : null;
                        }

                        patchItem =
                            getFirstValidItem(item.embroideryPatchItems) ||
                            getFirstValidItem(item.emptLineItems);

                        if (patchItem) {
                            currentItemCatalog = patchItem.designCatalog;
                            currentProductCode = patchItem.designItemId;
                        }
                    }
                    if (definitionName.toLowerCase() == "clubmembership") {
                        imgUrl =
                            "/embroiderydesigns/images/embroidery-circle/circle_logo.png";
                        return imgUrl.toLowerCase();
                    }

                    //#endregion

                    //#region Catalog
                    var catalog = "";

                    if (angular.isDefined(currentItemCatalog)) {
                        catalog = currentItemCatalog.replace(/ /g, "_");
                    }
                    if (catalog.toLowerCase() == "atg_freedesigns")
                        catalog = "anns_club";
                    else if (catalog.toLowerCase() == "annthegranpl")
                        catalog = "annthegran";
                    //#endregion

                    //#region Product Code
                    if (angular.isDefined(currentProductCode)) {
                        productCode =
                            currentProductCode.split(/-(.+)/).length > 1
                                ? currentProductCode.split(/-(.+)/)[1]
                                : currentProductCode.split(/-(.+)/)[0];
                    }
                    if (productCode.toLowerCase().indexOf("_var_") > -1) {
                        productCode = productCode.split(/_var_/gi)[0];
                    }
                    //#endregion

                    //#region RGB
                    var rgb = "";
                    if (angular.isDefined(item.rgb)) {
                        rgb = item.rgb;
                    }
                    //#endregion

                    //#region Size
                    var size = "";
                    if (angular.isDefined(item.size)) {
                        size = item.size;
                    }

                    if (size.length < 1) {
                        size = "large";
                    }
                    //#endregion

                    //#region Manufacturer Part Number
                    var manufacturerPartNumber = "";
                    if (angular.isDefined(item.product)) {
                        manufacturerPartNumber =
                            item.product.manufacturerPartNumber;
                    }
                    if (angular.isDefined(item.manufacturerPartNumber)) {
                        manufacturerPartNumber = item.manufacturerPartNumber;
                    }
                    //#endregion

                    //#region ImgBaseUrl
                    var imgBaseUrl = "https://img2.embroiderydesigns.com/"; // Default Fallback
                    if (
                        angular.isDefined(window.__env) &&
                        angular.isDefined(window.__env.storePrdImgUrl)
                    ) {
                        imgBaseUrl = window.__env.storePrdImgUrl;
                    }
                    //#endregion

                    //#region Threads
                    var showThreadVariants = false;
                    if (angular.isDefined(item.showThreadVariants)) {
                        showThreadVariants = item.showThreadVariants;
                    }
                    if (
                        definitionName.toLowerCase() == "thread" &&
                        showThreadVariants
                    ) {
                        imgUrl = imgBaseUrl + definitionName + "/" + size + "/";
                        if (
                            rgb != "" &&
                            angular.isDefined(item.threadConeImageName)
                        ) {
                            return (
                                "/common/images/thread_images/" +
                                item.threadConeImageName
                            ).toLowerCase();
                        } else {
                            imgUrl += "/threads/" + manufacturerPartNumber;
                            imgUrl += ".png";
                            return imgUrl.toLowerCase();
                        }
                    }
                    //#endregion

                    //#region ImgExtension
                    var imgExtension = ".webp";
                    if (
                        definitionName.toLowerCase() == "designpack" ||
                        definitionName.toLowerCase() == "fontpack"
                    ) {
                        imgExtension = ".webp";
                    }
                    //#endregion
                    //#region for Merchandise ProductCode
                    if (definitionName.toLowerCase() == "merchandise") {
                        if (angular.isDefined(item.sku)) {
                            productCode =
                                item.sku.split(/-(.+)/).length > 1
                                    ? item.sku.split(/-(.+)/)[1]
                                    : item.sku.split(/-(.+)/)[0];
                        }
                        var variantId = productCode.split(/_var_/gi)[1];
                        if (variantId == "1") {
                            productCode = productCode.split(/_var_/gi)[0];
                        }
                        definitionName = "merchandise";
                    }
                    //#endregion
                    if (definitionName.toLowerCase() == "personalizeddesign") {
                        if (
                            item.cartLineItemCustomProperties != undefined &&
                            item.cartLineItemCustomProperties.length > 0
                        ) {
                            definitionName =
                                item.cartLineItemCustomProperties[0]
                                    .pdOrigDefinitionName;
                            productCode =
                                item.cartLineItemCustomProperties[0].pdOrigItemId.split(
                                    "-"
                                )[1];
                            catalog =
                                item.cartLineItemCustomProperties[0].pdOrigCatalog.replace(
                                    /\s+/g,
                                    "_"
                                );
                        }
                    }
                    if (definitionName.toLowerCase() == "personalizeddesign") {
                        if (
                            item.orderLineItemCustomProperties != undefined &&
                            item.orderLineItemCustomProperties.length > 0
                        ) {
                            definitionName =
                                item.orderLineItemCustomProperties[0]
                                    .pdOrigDefinitionName;
                            productCode =
                                item.orderLineItemCustomProperties[0].pdOrigItemId.split(
                                    "-"
                                )[1];
                            catalog =
                                item.orderLineItemCustomProperties[0].pdOrigCatalog.replace(
                                    /\s+/g,
                                    "_"
                                );
                        } else {
                            return (imgUrl = "/noimage.webp");
                        }
                    }

                    imgUrl =
                        imgBaseUrl +
                        definitionName +
                        "/" +
                        size +
                        "/" +
                        catalog +
                        "/" +
                        productCode +
                        imgExtension;
                    return imgUrl.toLowerCase();
                }
            },
            getProductVideoUrl: function (item) {
                if (angular.isDefined(item)) {
                    var videoUrl = "";
                    var videoBaseUrl = "";
                    if (window.__env && window.__env.productVideosBaseUrl) {
                        videoBaseUrl = window.__env.productVideosBaseUrl;
                    }

                    //#region Catalog
                    var catalog = "";
                    if (angular.isDefined(item.catalogId)) {
                        catalog = item.catalogId.replace(/ /g, "_");
                    }
                    if (catalog.toLowerCase() == "atg_freedesigns")
                        catalog = "anns_club";
                    else if (catalog.toLowerCase() == "annthegranpl")
                        catalog = "annthegran";
                    //#endregion

                    //#region Product Code
                    var productCode = "";
                    if (angular.isDefined(item.sku)) {
                        productCode =
                            item.sku.split(/-(.+)/).length > 1
                                ? item.sku.split(/-(.+)/)[1]
                                : item.sku.split(/-(.+)/)[0];
                    }
                    if (productCode.toLowerCase().indexOf("_var_") > -1) {
                        productCode = productCode.split(/_var_/gi)[0];
                    }
                    //#endregion

                    videoUrl =
                        videoBaseUrl + catalog + "/" + productCode + ".mp4";
                    return videoUrl.toLowerCase();
                }
            },
            getQueryString: function (param, url) {
                var href = url ? url : $location.$$absUrl;
                var reg = new RegExp("[?&]" + param + "=([^&#]*)", "i");
                var string = reg.exec(href);
                return string ? string[1] : null;
            },
            getProductUrl: function (item) {
                if (angular.isDefined(item)) {
                    //#region Definition
                    var definition = "";
                    if (angular.isDefined(item.definitionName)) {
                        definition = item.definitionName
                            .replace(/_/g, "-")
                            .replace(/ /g, "-")
                            .toLowerCase();
                    } else if (angular.isDefined(item.productDefinition)) {
                        definition = item.productDefinition
                            .replace(/_/g, "-")
                            .replace(/ /g, "-")
                            .toLowerCase();
                    }
                    if (definition == "font-letter") {
                        definition = "fontletter";
                    }
                    //#endregion

                    //#region Brand
                    var brand = "";
                    if (angular.isDefined(item.catalogId)) {
                        brand = item.catalogId;

                        if (brand.toLowerCase() == "robison-anton") {
                            brand = "ct-company";
                        }
                    }
                    //#endregion

                    //#region ProductId
                    var productId = "";
                    if (angular.isDefined(item.sku) && item.sku !== null && item.sku !== "") {
                        productId = String(item.sku);
                    }
                    //#endregion

                    //#region Name
                    var title = "";
                    if (angular.isDefined(item.name)) {
                        title = item.name;
                    }
                    //#endregion

                    //#region LineItemId
                    var lineItemId = "";
                    if (angular.isDefined(item.id)) {
                        lineItemId = item.id;
                    }
                    //#endregion

                    //#region Cart Id
                    var cartId = undefined; // For GC on cart page
                    if (angular.isDefined(item.cartId)) {
                        cartId = item.cartId;
                    }
                    //#endregion

                    //#region cdRowId
                    var cdRowId = undefined; // For CD
                    if (
                        angular.isDefined(item.customDigitizingItems) &&
                        item.customDigitizingItems != null &&
                        item.customDigitizingItems.length > 0
                    ) {
                        cdRowId = item.customDigitizingItems[0].cdRowId;
                    } else if (
                        angular.isDefined(item.cdLineItems) &&
                        item.cdLineItems != null &&
                        item.cdLineItems.length > 0
                    ) {
                        cdRowId = item.cdLineItems[0].cdRowId;
                    }
                    //#endregion

                    //#region variant
                    var variant = 1;
                    //#endregion

                    if (angular.isDefined(definition)) {
                        if (definition.toLowerCase() == "project_tutorial" || definition.toLowerCase() === "project-tutorial") {
                            title = title
                                .replace(/\s|\/|\?/g, "-")
                                .replace(/&|\+/g, "")
                                .replace(/[^\w-]*/g, "")
                                .replace(/^[-]/g, "")
                                .replace(/[-]$/g, "")
                                .toLowerCase();
                            return (
                                "/how-to-embroider/project/" +
                                productId +
                                "/" +
                                title
                            ).toLowerCase();
                        } else if (definition.toLowerCase() == "lookbook") {
                            return (
                                "/learning-center/lookbooks?id=" + productId
                            ).toLowerCase();
                        } else if (catalogService.isSubscription(definition)) {
                            return "/account#/#customersubscription";
                        } else if (
                            definition.toLowerCase() == "giftcertificate" &&
                            angular.isUndefined(cartId)
                        ) {
                            return "/giftcard"; // Url on any other pages other than cart
                        } else if (
                            definition.toLowerCase() == "giftcertificate" &&
                            angular.isDefined(cartId) &&
                            angular.isDefined(lineItemId)
                        ) {
                            return (
                                "/giftcard?cartId=" +
                                cartId +
                                "&lineItemId=" +
                                lineItemId
                            ).toLowerCase(); // Url on cart page - ability to go back to GC page and change details if necessary
                        } else if (
                            definition.toLowerCase() == "customdigitizing"
                        ) {
                            return "customdigitizingdetails?cdrowid=" + cdRowId;
                        } else if (
                            definition.toLowerCase() == "instantlettering"
                        ) {
                            return "/onlinelettering";
                        } else if (
                            definition.toLowerCase() == "digitalshipping"
                        ) {
                            return "/design-backup";
                        }
                        else {
                            var normalizedDefinition = definition.toLowerCase();
                            if (
                                normalizedDefinition == "printart" ||
                                normalizedDefinition == "svg"
                            ) {
                                definition = "printart";
                            } else if (normalizedDefinition == "threads") {
                                definition = "thread";
                            } else if (
                                normalizedDefinition == "embroiderypatch"
                            ) {
                                definition = "patch";

                                var patchItem =
                                    (item.embroideryPatchItems &&
                                        item.embroideryPatchItems.length > 0 &&
                                        item.embroideryPatchItems[0]) ||
                                    (item.emptLineItems &&
                                        item.emptLineItems.length > 0 &&
                                        item.emptLineItems[0]) ||
                                    {};

                                if (patchItem.designCatalog) {
                                    brand = patchItem.designCatalog.replace(
                                        /_/g,
                                        "-"
                                    );
                                    productId =
                                        patchItem.designItemId +
                                        "_var_" +
                                        patchItem.designVariantId;
                                }
                            }

                            if (
                                angular.isDefined(brand) &&
                                brand.indexOf(" ") > 0
                            ) {
                                brand = brand.replace(/ |\//g, "-");
                            }
                            if (angular.isDefined(title) && title.length > 0) {
                                title = title
                                    .replace(/\s|\/|\\|\?/g, "-")
                                    .replace(/&/g, "");
                            }
                            if (
                                angular.isDefined(definition) &&
                                angular.isDefined(title) &&
                                title.indexOf("#") > 0
                            ) {
                                if (definition.toLowerCase() == "thread") {
                                    title = title.replace(/#/g, "-");
                                } else {
                                    title = title.replace(/#/g, "");
                                }
                            }
                            if (angular.isDefined(productId)) {
                                if (
                                    productId.toLowerCase().indexOf("_var_") > 1
                                ) {
                                    variant = productId.split(/_var_/gi)[1];
                                }
                                if (
                                    angular.isDefined(productId) &&
                                    productId.indexOf("-") > 1
                                ) {
                                    productId = productId
                                        .split(/-(.+)/)[1]
                                        .split(/_var_/gi)[0];
                                } else {
                                    productId = productId.split(/_var_/gi)[0];
                                }
                            }
                            if (
                                definition.toLowerCase() ==
                                    "personalizeddesign" &&
                                item.cartLineItemCustomProperties !=
                                    undefined &&
                                item.cartLineItemCustomProperties.length > 0
                            ) {
                                definition =
                                    item.cartLineItemCustomProperties[0]
                                        .pdOrigDefinitionName;
                                productId =
                                    item.cartLineItemCustomProperties[0].pdOrigItemId.split(
                                        "-"
                                    )[1];
                                brand =
                                    item.cartLineItemCustomProperties[0].pdOrigCatalog.replace(
                                        /\s+/g,
                                        "-"
                                    );
                            }
                            if (
                                definition.toLowerCase() ==
                                    "personalizeddesign" &&
                                item.orderLineItemCustomProperties !=
                                    undefined &&
                                item.orderLineItemCustomProperties.length > 0
                            ) {
                                definition =
                                    item.orderLineItemCustomProperties[0]
                                        .pdOrigDefinitionName;
                                productId =
                                    item.orderLineItemCustomProperties[0].pdOrigItemId.split(
                                        "-"
                                    )[1];
                                brand =
                                    item.orderLineItemCustomProperties[0].pdOrigCatalog.replace(
                                        /\s+/g,
                                        "-"
                                    );
                            }
                            var productUrl =
                                "productdetails/" +
                                brand +
                                "/" +
                                definition +
                                "/" +
                                variant +
                                "/" +
                                productId;
                            return productUrl.toLowerCase();
                        }
                    }
                }
            },
            getAuthorProjectsUrl: function (id, name) {
                if (angular.isDefined(id) && angular.isDefined(name)) {
                    name = name.replace(/\s|\/|\?/g, "-").replace(/&|\+/g, "");
                    return (
                        "/how-to-embroider/author/" +
                        name +
                        "/" +
                        id
                    ).toLowerCase();
                }
            },
            getCategoryImageUrl: function (name, type) {
                return (
                    window.__env.categoriesImgBaseUrl +
                    name.replace(/ /g, "-") +
                    ".jpg"
                );
            },
            getSubCategoryImageUrl: function (parentCategoryName, name) {
                return (
                    window.__env.subCategoriesImgBaseUrl +
                    parentCategoryName.replace(/ /g, "_") +
                    "/" +
                    name.replace(/ /g, "_") +
                    ".webp"
                );
            },
            trackCustomerViewProduct: function (productId) {
                return $http.get(
                    "storefrontapi/product/trackcustomerbrowse/" + productId
                );
            },
        };
    },
]);
//#endregion

//#region Loader Service
storefrontApp.service("loaderService", [
    "modalService",
    "$rootScope",
    function (modalService, $rootScope) {
        return {
            hide: function () {
                modalService.close("appLoader");
            },
            show: function () {
                modalService.open("appLoader");
            },
            showProgress: function () {
                $rootScope.$broadcast("loader_show_progress");
            },
            updateProgress: function (percentage) {
                $rootScope.$broadcast("loader_update_progress", percentage);
            },
        };
    },
]);
//#endregion

//#region Main Service
storefrontApp.service("mainService", [
    "$http",
    function ($http) {
        return {
            getNavbarContent: function () {
                return $http.get("storefrontapi/navbarcontent");
            },
            insertMailingListEmail: function (email, valid) {
                return $http.post(
                    "emailcampaign/insertmailinglistemail/" +
                        email +
                        "/" +
                        valid
                );
            },
            getSettingsByKey: function (key) {
                return $http.get("storefrontapi/settingsbykey?key=" + key);
            },
            getModuleKeys: function (key) {
                return $http.get("storefrontapi/modulekeys?key=" + key);
            },
            markEmailNotSpam: function (email) {
                return $http.get("emailcampaign/markemailnotspam");
            },
            getLoyaltyContent: function () {
                return $http.get("storefrontapi/embroidery-loyalty/content");
            },
        };
    },
]);
//#endregion

//#region Modal Service
storefrontApp.service("modalService", function () {
    var modals = [];
    var service = {};

    service.add = add;
    service.remove = remove;
    service.open = open;
    service.close = close;
    service.isRegistered = isRegistered;

    function add(modal) {
        modals.push(modal);
    }

    function remove(id) {
        var modalToRemove = _.findWhere(modals, { id: id });
        modals = _.without(modals, modalToRemove);
    }

    function open(id) {
        var modal = _.findWhere(modals, { id: id });
        modal && modal.open();
    }

    function close(id) {
        var modal = _.findWhere(modals, { id: id });
        modal && modal.close();
    }

    function isRegistered(id) {
        return !!_.findWhere(modals, { id: id });
    }

    return service;
});
//#endregion

//#region Random Service
storefrontApp.service("randomService", [
    function () {
        return {
            getRandomItemsfromListArray: function (data, range) {
                range =
                    angular.isUndefined(range) || range === null ? 6 : range;
                if (range > data.length) {
                    range = data.length;
                }
                var randomItems = [];
                for (var i = 0; i < range; i++) {
                    var idx = Math.floor(Math.random() * data.length);
                    randomItems.push(data[idx]);
                    data.splice(idx, 1);
                }
                return randomItems;
            },
        };
    },
]);
//#endregion

//#region RecentlyViewedService
storefrontApp.service("recentlyViewedService", [
    function () {
        return {
            updateRecentlyViewed: function (productId) {
                if (!(angular.isUndefined(productId) || productId == "")) {
                    productId = productId.toLowerCase();
                    var recentlyViewed = localStorage.getItem("recentlyViewed");
                    if (recentlyViewed === null) {
                        localStorage.setItem("recentlyViewed", productId);
                    } else {
                        recentlyViewed = recentlyViewed.split(",");
                        var index = recentlyViewed.indexOf(productId);
                        if (index !== -1) {
                            recentlyViewed.splice(index, 1);
                        }
                        if (recentlyViewed.length > 11) {
                            recentlyViewed.pop();
                            recentlyViewed.splice(0, 0, productId);
                        } else {
                            recentlyViewed.splice(0, 0, productId);
                        }
                        localStorage.setItem(
                            "recentlyViewed",
                            recentlyViewed.toString()
                        );
                    }
                }
            },
        };
    },
]);
//#endregion

//#region Cart Service
storefrontApp.service("cartService", [
    "$http",
    "$q",
    function ($http, $q) {
        function parseUnitPrice(listPrice, salePrice) {
            var list = parseFloat(listPrice);
            var sale = parseFloat(salePrice);
            if (!isNaN(sale) && sale > 0 && (!isNaN(list) ? sale < list : true)) {
                return sale;
            }
            return !isNaN(list) ? list : 0;
        }

        function resolveVariantUnitPrice(variants, productId) {
            if (!variants || !variants.length || productId.indexOf("_var_") === -1) {
                return null;
            }
            var variantId = productId.split("_var_")[1];
            var match = variants.filter(function (variant) {
                return String(variant.variantId) === String(variantId);
            })[0];
            if (!match) {
                return null;
            }
            return parseUnitPrice(match.listPrice, match.salePrice);
        }

        function resolveFromWindowProducts(productId) {
            if (!window.products || !window.products.length) {
                return null;
            }
            var match = null;
            for (var i = 0; i < window.products.length; i++) {
                var candidate = window.products[i];
                if (
                    candidate &&
                    (candidate.id === productId ||
                        productId.indexOf(candidate.id + "_var_") === 0)
                ) {
                    match = candidate;
                    break;
                }
            }
            if (!match) {
                return null;
            }

            var unitPrice = 0;
            if (match.variantIds && match.variantPrices) {
                var variantIds = String(match.variantIds).split("|");
                var variantPrices = String(match.variantPrices).split("|");
                if (productId.indexOf("_var_") > -1) {
                    var selectedVariantId = productId.split("_var_")[1];
                    var variantIndex = variantIds.indexOf(selectedVariantId);
                    if (variantIndex > -1) {
                        unitPrice = parseFloat(variantPrices[variantIndex]) || 0;
                    }
                }
                if (!unitPrice && variantPrices.length) {
                    unitPrice = parseFloat(variantPrices[0]) || 0;
                }
            }

            return {
                product_name: match.name || "",
                product_category: match.definitionName || "",
                unitPrice: unitPrice,
            };
        }

        function resolveAddToCartTracking(productId, quantity, trackingOptions) {
            var qty = quantity || 1;
            trackingOptions = trackingOptions || {};
            var payload = {
                product_id: productId,
                order_quantity: qty,
                currency: trackingOptions.currency || "USD",
                product_name: trackingOptions.product_name || trackingOptions.productName || "",
                product_category:
                    trackingOptions.product_category || trackingOptions.productCategory || "",
                value: trackingOptions.value != null ? parseFloat(trackingOptions.value) || 0 : 0,
            };
            var unitPrice =
                trackingOptions.product_price != null
                    ? parseFloat(trackingOptions.product_price) || 0
                    : 0;

            var windowProductContext = resolveFromWindowProducts(productId);
            if (windowProductContext) {
                if (!payload.product_name) {
                    payload.product_name = windowProductContext.product_name;
                }
                if (!payload.product_category) {
                    payload.product_category = windowProductContext.product_category;
                }
                if (!unitPrice) {
                    unitPrice = windowProductContext.unitPrice;
                }
            }

            if (!payload.product_name || !unitPrice) {
                try {
                    var pdpElement = document.querySelector(
                        '[data-ng-controller="productController"]'
                    );
                    if (pdpElement && angular) {
                        var pdpScope = angular.element(pdpElement).scope();
                        if (pdpScope && pdpScope.productInfo && pdpScope.productInfo._source) {
                            var src = pdpScope.productInfo._source;
                            if (!payload.product_name) {
                                payload.product_name = src.name || "";
                            }
                            if (!payload.product_category) {
                                payload.product_category = src.definitionName || "";
                            }
                            if (!unitPrice) {
                                unitPrice =
                                    resolveVariantUnitPrice(src.variants, productId) ||
                                    (pdpScope.activeProductVariant
                                        ? parseUnitPrice(
                                              pdpScope.activeProductVariant.listPrice,
                                              pdpScope.activeProductVariant.salePrice
                                          )
                                        : 0) ||
                                    parseUnitPrice(src.listPrice, src.salePrice);
                            }
                        }
                    }
                } catch (e) { /* scope lookup is best-effort */ }
            }

            if (!payload.product_name || !unitPrice) {
                try {
                    var quickViewElement = document.querySelector(
                        '[data-ng-controller="quickViewController"]'
                    );
                    if (quickViewElement && angular) {
                        var quickViewScope = angular.element(quickViewElement).scope();
                        var quickViewProduct =
                            quickViewScope &&
                            quickViewScope.quickView &&
                            quickViewScope.quickView.product;
                        if (quickViewProduct) {
                            if (!payload.product_name) {
                                payload.product_name = quickViewProduct.name || "";
                            }
                            if (!payload.product_category) {
                                payload.product_category = quickViewProduct.definitionName || "";
                            }
                            if (!unitPrice) {
                                unitPrice = parseUnitPrice(
                                    quickViewProduct.listPrice,
                                    quickViewProduct.salePrice
                                );
                            }
                        }
                    }
                } catch (e) { /* scope lookup is best-effort */ }
            }

            if (!unitPrice && payload.value && qty > 0) {
                unitPrice = payload.value / qty;
            }

            payload.value = unitPrice * qty;
            payload.line_items = [
                {
                    product_name: payload.product_name,
                    product_id: productId,
                    product_price: unitPrice,
                    product_quantity: qty,
                    product_category: payload.product_category,
                },
            ];
            return payload;
        }

        return {
            addLineItem: function (productId, quantity, stitchPlanIncluded, trackingOptions) {
                var requestBody = {
                    id: productId,
                    quantity: quantity,
                };
                
                // Add stitchPlanIncluded if provided
                if (angular.isDefined(stitchPlanIncluded)) {
                    requestBody.stitchPlanIncluded = stitchPlanIncluded === true;
                }
                
                var response = $http.post("storefrontapi/cart/items", requestBody);
                if (response && typeof response.then === "function") {
                    response.then(function (res) {
                        if (!res || !res.data) {
                            return;
                        }
                        var qty = quantity || 1;
                        if (typeof gtag !== "undefined" && gtag !== null) {
                            gtag("event", "add_to_cart", {
                                items: [
                                    {
                                        item_id: productId,
                                        quantity: qty,
                                    },
                                ],
                            });
                        }
                        if (typeof window.trackBing === "function") {
                            window.trackBing("add_to_cart", {
                                event_label: productId,
                                event_value: qty,
                            });
                        }
                        if (typeof window.trackPinterest === "function") {
                            window.trackPinterest(
                                "addtocart",
                                resolveAddToCartTracking(productId, qty, trackingOptions)
                            );
                        }
                        if (typeof window.trackMeta !== "function") {
                            return;
                        }
                        window.trackMeta("AddToCart", {
                            content_ids: [productId],
                            content_type: "product",
                            contents: [{ id: productId, quantity: qty }],
                            currency: "USD",
                        });
                    });
                }
                return response;
            },
            addAllVariantsAsLineItems: function (productId, quantity, definitionName) {
                var requestBody = {
                    id: productId,
                    quantity: quantity,
                    isBuyAllVariants: true,
                };
                if (definitionName) {
                    requestBody.definitionName = definitionName;
                }
                return $http.post("storefrontapi/cart/items", requestBody);
            },
            addMultipleProductsAsLineItems: function (
                productId,
                quantity,
                seriesId
            ) {
                return $http.post("storefrontapi/cart/items", {
                    id: productId,
                    quantity: quantity,
                    boughtTogetherSeriesMappedId: seriesId,
                });
            },
            removeLineItem: function (lineItemId) {
                return $http.delete(
                    "storefrontapi/cart/items?lineItemId=" + lineItemId
                );
            },
            removeLineItems: function (lineItemIds) {
                return $http.delete("storefrontapi/cart/multipleitems", {
                    params: { itemIds: lineItemIds },
                });
            },
            changeLineItemQuantity: function (lineItemId, quantity) {
                return $http.put("storefrontapi/cart/items", {
                    lineItemId: lineItemId,
                    quantity: quantity,
                });
            },
            getCustomerCart: function () {
                return $http.get(
                    "storefrontapi/cart?t=" + new Date().getTime()
                );
            },
            getCustomerCartMin: function () {
                return $http.get(
                    "storefrontapi/cart/totalitems?t=" + new Date().getTime()
                );
            },
            getCartItemSchema: function () {
                return $http.get("storefrontapi/cart/cartitemschema");
            },
            getCartForCheckout: function () {
                return $http.get(
                    "storefrontapi/cart/cartforcheckout?t=" +
                        new Date().getTime()
                );
            },
            addGiftCardProductToCart: function (
                product,
                recipientname,
                sendername,
                email,
                deliverydate,
                amount,
                message,
                giftcardimage,
                lineitemid
            ) {
                return $http.post("storefrontapi/cart/addgiftcardtocart", {
                    productid: product,
                    giftcardto: recipientname,
                    giftcardfrom: sendername,
                    giftcardtoemailid: email,
                    giftcarddeliverydate: deliverydate,
                    giftcardamount: amount,
                    giftcardmessage: message,
                    giftCardImage: giftcardimage,
                    lineItemId: lineitemid,
                });
            },
            addCoupon: function (couponCode) {
                var ccode = couponCode.toLowerCase();
                return $http.post("storefrontapi/cart/coupons/" + ccode);
            },
            removeCoupon: function (couponCode) {
                var ccode = couponCode.toLowerCase();
                return $http.delete(
                    "storefrontapi/cart/coupons?couponCode=" + ccode
                );
            },
            validateCoupon: function (coupon) {
                return $http.post(
                    "storefrontapi/cart/coupons/validate",
                    coupon
                );
            },
            getCartShippingEstimate: function (address) {
                return $http.post(
                    "storefrontapi/shipping/cartestimate",
                    address
                );
            },
            addInstantLetteringItemToCart: function (ilItem) {
                return $http.post("storefrontapi/cart/addilitemtocart", ilItem);
            },
            addEmbroideryPatchToCart: function (patchLineItem) {
                return $http.post(
                    "storefrontapi/cart/addpatchitemtocart",
                    patchLineItem
                );
            },
            checkItemsInCustomPack: function () {
                return $http.get("storefrontapi/cart/checkdesignsincustompack");
            },
            checkPotentialShippingDiscounts: function () {
                return $http.get(
                    "storefrontapi/shipping/getpotentialshippingdiscounts"
                );
            },
            getBuyXPercentOffNudges: function (cartItems) {
                return $http.post(
                    "storefrontapi/cartbuyxpercentoffnudges",
                    { cartItems: cartItems }
                );
            },
            addMembershipCart: function (planId, planTenure) {
                return $http.post("storefrontapi/cart/membershipcheckout", {
                    planId: planId,
                    planTenure: planTenure,
                });
            },
            moveListItemsToCart: function () {
                return $http
                    .post("storefrontapi/cart/movelistitemstocart")
                    .catch(function (err) {
                        if (
                            err &&
                            (err.status === -1 ||
                                err.xhrStatus === "abort")
                        ) {
                            return $q.when({ data: null });
                        }
                        return $q.reject(err);
                    });
            },
            guestCheckoutAccess: function (email) {
                return $http.get(
                    "storefrontapi/cart/accessguestcheckout/" + email
                );
            },
            addPersonalizedDesignToCart: function (lineItemCustomProperties) {
                return $http.post(
                    "storefrontapi/cart/addpditemtocart",
                    lineItemCustomProperties
                );
            },
            addDesignBackupItemToCart: function (payload) {
                return $http.post(
                    "storefrontapi/cart/adddesignbackupitemtocart",
                    payload
                );
            },
            fetchPersonalizedDesignPrice: function (payload) {
                return $http.post(
                    "storefrontapi/cart/fetchpersonalizeddesignprice",
                    payload
                );
            },
        };
    },
]);
//#endregion

// #region Favorites
storefrontApp.service("favoritesService", [
    "$http",
    function ($http) {
        return {
            getUserFavoriteItems: function (userId) {
                return $http.get(
                    "favorites/getfavoriteitemsbyuserid?userId=" +
                        userId +
                        "&t" +
                        Date.now()
                );
            },
            deleteItemFromFavorites: function (prodId, userId, grpName) {
                return $http.post("favorites/deleteitemfromfavorites", {
                    UserId: userId,
                    SKU: prodId,
                    GroupName: grpName,
                });
            },
            addItemToFavorites: function (prodId, userId, grpName) {
                var response = $http.post("favorites/additemtofavorites", {
                    userId: userId,
                    SKU: prodId,
                    GroupName: grpName,
                });
                if (response && typeof gtag !== "undefined" && gtag !== null) {
                    gtag("event", "add_to_wishlist", {
                        items: [
                            {
                                item_id: prodId,
                            },
                        ],
                    });
                }
                return response;
            },
            addBrandToFavorites: function (userId, brandName) {
                return $http.post("favorites/addbrandtofavorites", {
                    FK_UserId: userId,
                    BrandName: brandName,
                });
            },
            removeBrandFromFavorites: function (userId, brandName) {
                return $http.post("favorites/deletebrandfromfavorites", {
                    FK_UserId: userId,
                    BrandName: brandName,
                });
            },
            getFavoriteBrands: function (userId) {
                return $http.get(
                    "favorites/getfavoritebrandsbyuserid?userId=" +
                        userId +
                        "&t" +
                        Date.now()
                );
            },
            getFavoritegroups: function (userId) {
                return $http.get(
                    "favorites/getfavoritegroupsbyuserid?userId=" +
                        userId +
                        "&t" +
                        Date.now()
                );
            },
            createFavoritesGroup: function (favoritesGroup) {
                return $http.post(
                    "favorites/additemtofavorites",
                    favoritesGroup
                );
            },
            updateItemsFavoritesGroup: function (favoritesGroup) {
                return $http.post("favorites/updateitemsfavoritesgroup", {
                    FK_UserId: favoritesGroup.userId,
                    groupName: favoritesGroup.groupName,
                    itemIds: favoritesGroup.itemIds,
                });
            },
        };
    },
]);
//#endregion

// #region Sales / Specials
storefrontApp.service("specialsService", [
    "$http",
    function ($http) {
        return {
            getActiveSales: function (allSales) {
                return $http.get(
                    "storefrontapi/activesales?allsales=" + allSales
                );
            },
        };
    },
]);
storefrontApp.service("helperService", [
    "$http",
    function ($http) {
        return {
            getResetCacheState: function (key) {
                return $http.get(
                    "storefrontapi/cachesettingsbyconfigkey?key=" + key
                );
            },
            isValidTimeZone: function (tz) {
                try {
                    Intl.DateTimeFormat(undefined, { timeZone: tz });
                    return true;
                } catch (ex) {
                    return false;
                }
            },
            getCSTTimeZone: function (time) {
                if (this.isValidTimeZone("CST")) {
                    return new Date(
                        time.toLocaleString("en-US", { timeZone: "CST" })
                    ).getDate();
                } else {
                    return new Date(Date.now()).getDate();
                }
            },
            getContent: function (value) {
                if (angular.isUndefined(value) || value === null) {
                    return null;
                }
                var storedValues = value.split("expiry:");
                if (storedValues != null && storedValues.length > 1) {
                    var currentDate = window.currentDate
                        .toString()
                        .match(/\d{1,2}\/\d{1,2}\/\d{4}/)[0];
                    var regexValues = storedValues[1].match(
                        /\d{1,2}\/\d{1,2}\/\d{4}/
                    );
                    if (regexValues != null) {
                        var storedDate = regexValues[0];
                        if (storedDate == currentDate) {
                            return storedValues[0];
                        }
                    }
                    return null;
                }
                return null;
            },
            downloadFileFromUrl: function (url, fileName) {
                fetch(url).then(function (t) {
                    return t.blob().then(function (b) {
                        var a = document.createElement("a");
                        a.href = URL.createObjectURL(b);
                        a.setAttribute("download", fileName);
                        a.click();
                    });
                });
            },
        };
    },
]);
//#endregion

//#region Month Service
storefrontApp.service("monthService", function () {
    this.monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
});
//#endregion

//#region Digital Event Formatter Service
storefrontApp.service("digitalEventFormatterService", ["monthService", function (monthService) {
    function formatTime12Hour(hours24, minutes) {
        var period = hours24 >= 12 ? "PM" : "AM";
        var hours12 = hours24 % 12;
        if (hours12 === 0) {
            hours12 = 12;
        }
        var hourStr = hours12 < 10 ? "0" + hours12 : String(hours12);
        var minuteStr = (minutes < 10 ? "0" : "") + (minutes || 0);
        return hourStr + ":" + minuteStr + " " + period;
    }

    function parseIsoDateTime(isoString) {
        var dateParts = isoString.split("T");
        var datePart = dateParts[0];
        var timePart = dateParts[1].replace("Z", "");
        var dotIndex = timePart.indexOf(".");
        if (dotIndex > -1) {
            timePart = timePart.substring(0, dotIndex);
        }

        var dateArray = datePart.split("-");
        var timeArray = timePart.split(":");

        return {
            year: parseInt(dateArray[0], 10),
            month: parseInt(dateArray[1], 10),
            day: parseInt(dateArray[2], 10),
            hours: parseInt(timeArray[0], 10),
            minutes: parseInt(timeArray[1], 10)
        };
    }

    return {
        formatTime12Hour: formatTime12Hour,
        enrichEvent: function (event) {
            var dateStr = event.goLive || event.eventStartDate;
            if (!dateStr) {
                return event;
            }

            try {
                var parsed = parseIsoDateTime(dateStr);
                var monthName = monthService.monthNames[parsed.month - 1];
                var formattedEventDate = monthName + " " + parsed.day + ", " + parsed.year;
                var formattedStartTime = formatTime12Hour(parsed.hours, parsed.minutes);

                var result = {};
                for (var key in event) {
                    if (event.hasOwnProperty(key)) {
                        result[key] = event[key];
                    }
                }

                result.eventDate = formattedEventDate;
                result.eventDateTime = formattedEventDate + " @ " + formattedStartTime;
                result.eventStartTime = formattedStartTime;

                if (event.eventDuration) {
                    var totalMinutes = parsed.hours * 60 + parsed.minutes + event.eventDuration;
                    var endHours = Math.floor(totalMinutes / 60) % 24;
                    var endMinutes = totalMinutes % 60;
                    result.eventEndTime = formatTime12Hour(endHours, endMinutes);
                }

                return result;
            } catch (error) {
                console.error("Error processing event:", error);
                return event;
            }
        }
    };
}]);
//#endregion
